import { Station } from '@app/core/types/stations';
import { stationsStationsGetAllQueryKey, useStationsStationsGetAll } from '@mi-front/api-v2';
import { useQueryClient } from '@tanstack/react-query';

/**
 * React Query hook for stations list via api-v2 generated query.
 * Cache is primed from app-init in AuthBootstrap using the api-v2 query key.
 * Use useStations() for the array; use this hook when you need query state (isLoading, refetch, etc.).
 *
 * OpenAPI for `/stations/v1` is incomplete; runtime payload matches app `Station` (WebAppStationDto).
 */
export function useStationsQuery() {
  return useStationsStationsGetAll<Station[]>(undefined, {
    query: {
      staleTime: Infinity,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      select: (data) => data as unknown as Station[],
    },
  });
}

useStationsQuery.queryKey = stationsStationsGetAllQueryKey;

/** Invalidates the stations list cache so active subscribers refetch from api-v2. */
export function useStationsRefetch() {
  const client = useQueryClient();

  return () => client.invalidateQueries({ queryKey: useStationsQuery.queryKey() });
}
